import { Box, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const calcBannerHeight = (theme: Theme) => {
  const buttonPosition = parseInt(theme.spacing(6));
  let emptySpace = buttonPosition;
  if (theme.mixins.toolbar.minHeight) {
    emptySpace += parseInt(theme.mixins.toolbar.minHeight.toString(), 10);
  }

  return `${emptySpace}px`;
};

const useStyles = makeStyles()((theme: Theme) => ({
  banner: {
    display: 'block',

    width: '100%',
    minHeight: theme.spacing(20),
    height: `calc(100vh - ${calcBannerHeight(theme)})`,
    [theme.breakpoints.only('xs')]: {
      height: `calc(65vh - ${calcBannerHeight(theme)})`,
    },
  },
  placeholderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholder: {
    display: 'block',
    height: '40vh',
  },
}));

type BannerProps = {
  src?: string;
  placeHolder: string;
  objectFit?: 'cover' | 'contain';
  onError?: () => void;
};

const Banner = ({ objectFit = 'cover', src, placeHolder, onError }: BannerProps) => {
  const { classes, cx } = useStyles();

  if (src) {
    return (
      <img
        alt="banner"
        className={classes.banner}
        style={{ objectFit }}
        src={src}
        onError={onError}
      />
    );
  }

  return (
    <Box className={cx(classes.banner, classes.placeholderContainer)}>
      <img
        alt="banner"
        className={classes.placeholder}
        style={{ objectFit }}
        src={placeHolder}
        onError={onError}
      />
    </Box>
  );
};

export default Banner;
